import { render, staticRenderFns } from "./ModalLicense.vue?vue&type=template&id=573aef6b&scoped=true"
import script from "./ModalLicense.vue?vue&type=script&lang=js"
export * from "./ModalLicense.vue?vue&type=script&lang=js"
import style0 from "./ModalLicense.vue?vue&type=style&index=0&id=573aef6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573aef6b",
  null
  
)

export default component.exports